import React from 'react';
import "./LoginContainer.css";
import { loginRequest } from "../../redux/actions/authActions";
import { useNavigate } from 'react-router-dom';
import { connect, useDispatch } from "react-redux";
import Spinner from 'react-bootstrap/Spinner';
import logo from '../../assets/icons/logo-sm.png'

const LoginContainer = (props) => {
  const { loading } = props;
  const history = useNavigate();
  const dispatch = useDispatch();

  const handleKeycloakLogin = () => {
    dispatch(loginRequest(history));
  };

  return (
    !loading ? (
      <div className="login-full-container">
        <div className="login-card">
          <div className="login-image">
            <img 
              src={logo}
              alt="Login"
            />
          </div>
          <div className="login-form">
            <h2>Bienvenido</h2>
            <p>Inicia sesión para continuar</p>
            <button 
              type="button" 
              className='btn-login-keycloak' 
              onClick={handleKeycloakLogin}
            >
              Iniciar sesión
            </button>
          </div>
        </div>
      </div>
    ) : (
      <div className="contenedor-spinner">
        <Spinner animation="border" role="status" size='lg'>
          <span className="visually-hidden">Cargando...</span>
        </Spinner>
      </div>
    )
  );
};

const mapStateToProps = (state) => {
  return {
    loading: state.auth.loading,
  };
};

export default connect(mapStateToProps)(LoginContainer);
